<template>   
  <div @mouseover="setHover(false)" ref="container" style="width:100%;overflow:hidden;" :class="{zoom:keyShiftPressed && allowZoom}" >         
    <div ref="graphs" style="position:relative" :id="`contnav_${safe_prefixe}${uiid}`">                  
      <v-alert
          v-model="alert"
          dismissible     
          type="info"
          style="position:absolute;z-index:10;width:100%"      
        >
          {{this.$t('Pilot.Graphics.ErrorSelectedCycle')}}
      </v-alert>      
      <canvas v-show="true" class="canvas backcanvas" ref="canvasLines"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>        
      <canvas v-show="false" class="canvas" ref="canvasPoints"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>
                 
      <canvas class="canvas" v-show="true"  ref="canvasPointsGl"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>           
      <canvas v-show="true" class="canvas" ref="canvasSelectedLines"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>
      <canvas v-show="true" class="canvas" ref="canvasSelectedPoints"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>
      <canvas v-show="true" class="canvas" ref="canvasSelectedShape"
        width="100"      
        height="100"      
        :style="{top:margin.top+'px',left:margin.left+'px'}"></canvas>
      <svg class="svg" :id="`svgnav_${safe_prefixe}${uiid}`" xmlns="http://www.w3.org/2000/svg"
        :width="width+'px'"
        :height="height+'px'"        
        v-if="domains.x">              
      </svg>    
      <v-progress-circular v-if="loading" indeterminate color="primary" :style="{zIndex:1000,position:'absolute',left:'50%',top:'50%',marginTop:((margin.top/2)-16)+'px',marginLeft:((margin.left/2)-16)+'px'}"></v-progress-circular>                
      <v-icon v-if='!isAllowed' :style="{position:'absolute',left:'50%',top:'50%',marginTop:((margin.top/2)-16)+'px',marginLeft:((margin.left/2)-16)+'px'}">mdi-lock</v-icon>
    </div>       
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'      
  import {Delaunay} from "d3-delaunay"
  import * as d3 from 'd3'  
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'
  import apiMission from '@/api/mission'    
  import { scan } from 'd3-array';
  import {dataLimitMode} from '@/models/ui/GraphUiState'
  import {AloMission, filterLastData} from '@/models/alo/AloMission'
  import { mustIgnoreValue } from '../../utils/autoscale'
  import * as THREE from 'three'
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
  import { getWidth } from 'ol/extent'
  import { reduce } from 'lodash'  
  import {chartColor} from '@/utils/autoscale'
import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'
import { buildCoverageIterationUiStateId } from '@/models/ui/CoverageIterationUiState'


  const IMAGE_CACHE_WIDTH = 500
  const IMAGE_CACHE_HEIGHT = 500

  const GRAPHS_COLORS = chartColor// [/*'#ec7404','#4066aa',*/'#ff6f60','#76d275','#ff5c8d']
  
  export default {
   name: 'MissionScatterPlotWebGl',     
   props:  {
    prefixe:{
        type:String,
        default: ''
      },
      uiid:{
          type: String,
          required: true
      },
      pointSize:{
        type: Number,
        default:2
      },
      mainVariable:{
        type:String,
        required: false,
        default:''
      },
      abscisseVariable:{
        type:String,
        required: true,
      },
      ordonneeVariable:{
        type:String,
        required: true,
      },
      colorVariable:{
        type:String,
        required: true,
      },
      colorSingle:{
        type:String,
        default:"#"
      },
      colorMin:{
        type:String,
        default:"#2c7bb6"
      },
      colorMid:{
        type:String,
        default:"#ffff8c"        
      },
      colorMax:{
        type:String,
        default:"#d7191c" 
      },
      allowClick:{
        type:Boolean,
        default:true
      },
      allowZoom:{
        type:Boolean,
        default:true
      },
      marginWidth:{
        type:Number,
        default:15
      },      
      defaultLineHeight:{
        type:Number,
        default:11
      },      
      offsetLegendX:{
        type:Number,
        default:10
      },
      axisHeightX:{
        type:Number,
        default:18
      },
      offsetLegendY:{
        type:Number,
        default:10
      },  
      axisWidthY:{
        type:Number,
        default:30
      },
      colorGradientWidth:{
        type:Number,
        default:20
      },
      offsetLegendColor:{
        type:Number,
        default:10
      },  
      axisWidthColor:{
        type:Number,
        default:30
      },
      xTicks:{
        type:Number,
        default:0
      },
      yTicks:{
        type:Number,
        default:0
      },
      colorTicks:{
        type:Number,
        default:0
      },
      dataLimit:{
        type:String,
        default:dataLimitMode.ALL
      },
      useCacheImg:{
        type:Boolean,
        default:false
      },
      forceGenereCache:{
        type:Boolean,
        default:false
      },
      useVoronoi: {
        type:Boolean,
        default:false
      },
      redraw:{
        type:Boolean,
        default:false
      },
      sciGraph:{
        type:Boolean,
        default:true
      },       
      simuGraph:{
        type:Boolean,
        default:false
      },
      custDomainX:{
        type:Array
      },
      custDomainY:{
        type:Array
      },
      custDomainColor:{
        type:Array
      },
      autoScaleX:{
        type:Boolean,
        default:false
      },
      autoScaleY:{
        type:Boolean,
        default:false
      },
      graphHoverMode:{
        type:Boolean,
        default:false
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
   },        
    data() {
      return {       
        refreshEveryMs:40,
        canMovePointer:true,
        canPanOrZoom:true,
        canDrawGraph:true,         
        width :100,
        height :100,
        t : d3.transition().duration(500),
        xTopAxis: null,
        xAxis: null,
        yAxis: null,
        colorAxis: null,
        xGrid: null,
        yGrid: null,
        gxAxis: null,
        gxText: null,
        gyAxis: null,
        gyText: null,
        gColorAxis: null,
        gColorText: null,
        overlay:null,
        focus:null,
        gxGrid: null,
        gyGrid: null,
        svg: null,    
        colorGradient: null,    
        colorLegend: null,    
        colorLegendRect: null,    
        contextLines: null,
        contextPoints: null,
        contextSelectedLines: null,
        contextSelectedPoints: null,
        contextSelectedShape: null,
        contextPointsGl:null,
        canvasColor: null,
        zoom_function : null,        
        alert: false,
        imagecache:null,
        isRender:false,
        zoomDomainX:null,
        zoomDomainY:null,        
        isAllowed:true,
        genereCache:false, //f
        loading:true,
        
        // ---------------------------
        // WEBGL and THREEJS data
        // ---------------------------
        renderer: null,
        container: null,
        scene: null,
        need_update: null,
        camera: null, 
        controls: null,
        near: 0, 
        far: 50, 
        hasControls: null,

        // -- Structure -- //
        bufferGeometry: null,
        pointsMaterial: null,
        points: null,
        pointsContainer: null,
        vertices: null,
        colors: null,
        linePositions: null,
        lineColors: null,
        lineMaterial: null,

        // Nearest detector
        pointer: null,
        accuracy: null,
        webgl_zoom: null,
        worldPointer3d: null,
        worldPointer2d: null,
        pointerColor: null,
        intersection: null,
        intersections: null,        
        rayCaster: null,
        rayCasters: null,
        rayCasters2: null,
        rayThresholds: null,
        nRays: null,
        webgl_transform_ref: null,
        webgl_accuracies: null,
        animationID: null,
        
        updateSizeId: null,
      
        pointer3d: null,
        pointer2d: null,
        plane  : null,
      }
    },
   computed: {
       ...mapGetters([                     
         'uistatebyuiid',
         'isDrawerOpen',
         'isRightDrawerOpen',
         'keyShiftPressed'
      ]),        
      safe_prefixe(){
        return this.prefixe.replace(/\./g,'_')
      },
      currentLang(){
        return this.$i18n.locale
      },
      margin() {
        return  {
          top:this.invertedOrdonnee?this.marginWidth + this.defaultLineHeight + this.offsetLegendX + this.axisHeightX :this.marginWidth, 
          left:this.marginWidth + this.defaultLineHeight + this.offsetLegendY + this.axisWidthY, 
          bottom:this.invertedOrdonnee?this.marginWidth + 5 + 2:this.marginWidth + this.defaultLineHeight + this.offsetLegendX + this.axisHeightX + 5, 
          right:this.marginWidth + this.axisWidthColor + this.colorGradientWidth + this.offsetLegendColor + this.defaultLineHeight + this.offsetLegendColor}//this.colorVariable != "None"?this.marginWidth + this.axisWidthColor + this.colorGradientWidth + this.offsetLegendColor + this.defaultLineHeight + this.offsetLegendColor :this.marginWidth + 5}
      },
      imgName() {        
        return `${this.sciGraph?'sci':this.simuGraph?'simu_':'nav'}_${this.mission.gliKey}_M${this.mission.misIdx.toString().padStart(3,'0')}-${this.abscisseVariable}-${this.ordonneeVariable}-${this.colorVariable}-${this.dataLimit}.jpg`
      },
      invertedOrdonnee(){        
        return this.ordonneePlotvariable && this.ordonneePlotvariable.invertedYAxis
      },
      colorList(){
        return [{variable:'None',name:'None'},...(this.plotVariables)]
      },
      graphUiState() {          
        //retourne un GraphUiState        
        return this.uistatebyuiid(this.uiid)
      }, 
      missionUiid(){
        return this.mission.covId?buildCoverageIterationMissionUiStateId(buildCoverageIterationUiStateId(this.mission.covId,this.graphUiState.typeUiid),`GLIDER${this.mission.misIdx+1}`) :buildMissionUIStateId(this.mission.misId,this.graphUiState.typeUiid)        
      },
      missionState(){
        return this.mission.covId?this.$store.myGetters.coverageIterationMissionUiStateByUiid(this.missionUiid):this.uistatebyuiid(this.missionUiid)
      },
      infosPanelVisible(){
        return this.missionState.infosPanelVisible
      },      
      refreshGraphCache(){
        return this.sciGraph?this.missionState.refreshSciGraphCache:this.missionState.refreshNavGraphCache
      },
      importedCsvHeaders(){
        return this.sciGraph?this.missionState.importedCsvHeaders:null
      },
      hoverData() {                        
        return this.sciGraph?this.missionState.sciHoverData:this.simuGraph?this.missionState.simuHoverData:this.missionState.navHoverData
      },
      hoverOrdonnee1Variable() {
        return this.ordonneePlotvariable.variables.length>0?this.ordonneePlotvariable.variables[0]:this.ordonneeVariable      
      },
      hoverOrdonnee2Variable() {
        return this.ordonneePlotvariable.variables.length>1?this.ordonneePlotvariable.variables[1]:this.ordonneeVariable      
      },
      plotVariables(){        
        return this.sciGraph?this.mission.sciPlotVariables:this.simuGraph?this.mission.simuPlotVariables:this.mission.navPlotVariables
      },
      abscissePlotvariable() {
        return this.plotVariables.find(v => v.variable == this.abscisseVariable)
      },      
      ordonneePlotvariable() {        
        return this.plotVariables.find(v => v.variable == this.ordonneeVariable)
      },  
      zoomVariable() {
        return this.graphUiState.zoom
      },
      colorPlotvariable(){
        return this.colorList.find(v => v.variable == this.colorVariable)
      },
      transform(){
        return this.allowZoom?this.graphUiState.transform:d3.zoomIdentity
      },            
      currentYosIndex(){
        return this.missionState.timelineIndex != -1?this.missionState.timelineIndex:(this.mission.yoArray.length-1)
      },
      currentRangeIndex(){
        return (this.mission.covId == null && this.missionState.rangeTimelineIndex[0] != -1)?this.missionState.rangeTimelineIndex:[0,this.mission.yoArray.length-1]
      },
      currentCycle(){
        return this.mission.yoArray[this.currentYosIndex].yosCycle
      },
      currentRangeCycle() {                
        //correctif suppression des points apres redemarrage glider yo 1 sur meme mission                                
        return [this.mission.yoArray[this.currentRangeIndex[0]].yosCycle,Math.max(...this.mission.yoArray.slice(this.currentRangeIndex[0],this.currentRangeIndex[1]+1).map(y => y.yosCycle))]
      },
      leftPanelWidth(){
        return this.tabState.leftPanelWidth
      },
      svgWidth() {
        return this.genereCache?IMAGE_CACHE_WIDTH:(this.width - this.margin.left - this.margin.right)
      },         
      svgHeight() {
        return this.genereCache?IMAGE_CACHE_HEIGHT:(this.height - this.margin.top - this.margin.bottom)
      }, 
      missionDomains() {        
        return {                              
          x: this.autoScaleX?this.mission.domainsAutoScale[this.dataLimit][this.abscisseVariable]:this.mission.domains[this.dataLimit][this.abscisseVariable],
          y: this.autoScaleY?this.mission.domainsAutoScale[this.dataLimit][this.ordonneeVariable]:this.mission.domains[this.dataLimit][this.ordonneeVariable]
        }
      },
      domains() {        
        return {                              
          x: this.zoomDomainX || this.custDomainX || this.missionDomains.x,
          y: this.zoomDomainY || this.custDomainY || this.missionDomains.y,
          c: this.custDomainColor || this.mission.domainsColor[this.dataLimit][this.colorVariable] || [0,0,0]
        }
      },
      domainZoomFact(){
        return {
          x: this.zoomDomainX != undefined?Math.abs((this.zoomDomainX[1] - this.zoomDomainX[0]) / (this.missionDomains.x[1] - this.missionDomains.x[0])):(this.custDomainX != undefined?Math.abs((this.custDomainX[1] - this.custDomainX[0]) / (this.missionDomains.x[1] - this.missionDomains.x[0])):1),
          y: this.zoomDomainY != undefined?Math.abs((this.zoomDomainY[1] - this.zoomDomainY[0]) / (this.missionDomains.y[1] - this.missionDomains.y[0])):(this.custDomainY != undefined?Math.abs((this.custDomainY[1] - this.custDomainY[0]) / (this.missionDomains.y[1] - this.missionDomains.y[0])):1)
        }
      },
      datas() {                        
        switch(this.dataLimit) {
          case dataLimitMode.LAST_24H : return this.sciGraph?filterLastData(24,this.mission.xSciScatterVariable,this.mission.dataScience)
                                              :this.simuGraph?filterLastData(24,this.mission.xSimuScatterVariable,this.mission.dataSimulation)
                                              :filterLastData(24,this.mission.xNavScatterVariable,this.mission.dataNavigation)
          case dataLimitMode.LAST_12H : return this.sciGraph?filterLastData(12,this.mission.xSciScatterVariable,this.mission.dataScience)
                                              :this.simuGraph?filterLastData(12,this.mission.xSimuScatterVariable,this.mission.dataSimulation)
                                              :filterLastData(12,this.mission.xNavScatterVariable,this.mission.dataNavigation)
          default: return this.sciGraph?this.mission.dataScience:this.simuGraph?this.mission.dataSimulation:this.mission.dataNavigation
        }        
      },  
      datasToDraw(){
        const ordonneeToPlot = this.ordonneePlotvariable.variables?this.ordonneePlotvariable.variables:[this.ordonneeVariable]

        //(data.yosCycle>=this.currentRangeCycle[0] && data.yosCycle<=this.currentRangeCycle[1])
        //if(mustIgnoreValue(data[ordonneeVariable],this.ordonneePlotvariable && this.ordonneePlotvariable.logarithmeAxis) || mustIgnoreValue(data[this.abscisseVariable],this.abscissePlotvariable && this.abscissePlotvariable.logarithmeAxis) || (hasColorVariable && mustIgnoreValue(data[this.colorVariable],this.colorPlotvariable && this.colorPlotvariable.logarithmeAxis))) return;
        let conditionValide = (data) => {                
            return (
              //les données des ordonnées ne sont pas a ignorer
              ordonneeToPlot.reduce((valide,ordonneeVariable) => {
                return valide || !mustIgnoreValue(data[ordonneeVariable],this.ordonneePlotvariable && this.ordonneePlotvariable.logarithmeAxis)
              },false) &&
              //les données d'abscisse ne sont pas a ignorer
              !mustIgnoreValue(data[this.abscisseVariable],this.abscissePlotvariable && this.abscissePlotvariable.logarithmeAxis) && 
              //si couleur les données couleur ne sont pas a ignorer 
              !(this.colorVariable != "None" && mustIgnoreValue(data[this.colorVariable],this.colorPlotvariable && this.colorPlotvariable.logarithmeAxis))                   
            )
        }
        return this.graphHoverMode?this.datas.filter(conditionValide):this.datas.filter(data => conditionValide(data) && data.yosCycle>=this.currentRangeCycle[0] && data.yosCycle<=this.currentRangeCycle[1])
      },
      scale() {
        return {
            x : (this.abscissePlotvariable && this.abscissePlotvariable.typeData == "date"?d3.scaleUtc():
                (this.abscissePlotvariable && this.abscissePlotvariable.logarithmeAxis?d3.scaleLog():d3.scaleLinear()))
                .domain(this.domains.x) // input
                .range([0, this.svgWidth])
                .nice(),
            y: (this.ordonneePlotvariable && this.ordonneePlotvariable.typeData == "date"?d3.scaleUtc():
                 (this.ordonneePlotvariable && this.ordonneePlotvariable.logarithmeAxis?d3.scaleLog():d3.scaleLinear()))
                .domain(this.domains.y) // input 
                .range(this.invertedOrdonnee?[0, this.svgHeight]:[this.svgHeight, 0])
                .nice(),
            c: (this.colorPlotvariable && this.colorPlotvariable.typeData == "date"?d3.scaleUtc():
               (this.colorPlotvariable && this.colorPlotvariable.logarithmeAxis?d3.scaleLog():d3.scaleLinear()))
                .domain(this.domains.c)                
                .range([this.colorMin, this.colorMid, this.colorMax])
                .interpolate(d3.interpolateHcl), 
            cv: (this.colorPlotvariable && this.colorPlotvariable.typeData == "date"?d3.scaleUtc():
                 (this.colorPlotvariable && this.colorPlotvariable.logarithmeAxis?d3.scaleLog():d3.scaleLinear()))
                .domain(this.domains.c)                
                .range([this.svgHeight,this.svgHeight/2, 0])                
        }
      },      
      zoomScale() {        
        return  {
            x : this.allowZoom && this.zoomVariable != "ZoomYAxis"?this.transform.rescaleX(this.scale.x):this.scale.x,
            y : this.allowZoom && this.zoomVariable != "ZoomXAxis"?this.transform.rescaleY(this.scale.y):this.scale.y
        }
      }, 
      graphHover(){
        return this.$store.myGetters.graphHover
      }  
    },
    watch:{        
      graphHover(newValue,oldValue){        
        if(this.graphHoverMode && this.pointer &&  this.graphHover.sciGraph == this.sciGraph &&  this.graphHover.simuGraph == this.simuGraph) {          
          
          this.pointer.x = this.graphHover.pointerX
          this.pointer.y = this.graphHover.pointerY          
          // this.webgl_compute_nearest()          
          // this.renderer.render(this.scene, this.camera)        
          this.webgl_pointerScale()   
          //console.log(this.pointer)
          this.webgl_compute_nearest()          
          this.renderer.render(this.scene, this.camera)        
        }    
      },
      currentLang(newLang){
        this.drawGraph()
      },
      leftPanelWidth(newWidth){
        if(this.$refs.container) {
          //console.log("leftPanelWidth",newWidth)
          const newW = this.$refs.container.clientWidth    
          //regarde si on doit attendre la fin de l'animation du redimensionnement      
          const timeout = newW == this.width?270:0          
          setTimeout(() => {            
            this.updateSize()
          },timeout)          
        }
      },
      imgName(newValue){
        if(this.useCacheImg && this.imagecache) {
          this.updateImageUrl()          
        }        
      },
      redraw(newValue) {
        //evite l'appel sur l'initialisation                         
        if(this.isRender) {                                
          setTimeout(this.updateSize,200)
        }
      },
      currentRangeCycle(newValue) {
        if(!this.graphHoverMode)this.webgl_rebuild()
        this.drawGraph()
      },
      useVoronoi(newValue){
        this.drawGraph()
      },
      pointSize(newValue){
        this.webgl_rebuild()
        this.drawGraph()
      },
      margin(newValue){
        if(this.isRender) this.updateSvgPosition()
      },
      scale(newScale) {               
        this.webgl_rebuild() 
        this.drawGraph()
      },
      currentCycle(newValue){        
        this.drawCurrentCycle()
      },           
      zoomVariable(newValue){
        this.drawGraph()
      },
      isDrawerOpen(newValue){
        this.updateSize()
      },
      isRightDrawerOpen(newValue){
        setTimeout(()=>this.updateSize(),500)
      },
      infosPanelVisible(newValue){
        this.updateSize()
      },
      hoverData(newValue) {
        if(this.focus && this.isAllowed) {
          if(newValue && newValue[this.abscisseVariable]) {
            const x = this.zoomScale.x(newValue[this.abscisseVariable])            
            const y = this.zoomScale.y(newValue[this.hoverOrdonnee1Variable])
            const y2 = this.zoomScale.y(newValue[this.hoverOrdonnee2Variable])
            if(!isNaN(x) && !isNaN(y)){
              this.focus.style('display', null)   
              this.focus.select('#focusCircle').attr('cx', x).attr('cy', y)
              this.focus.select('#focusLineX').attr('x1', x).attr('x2', x)
              this.focus.select('#focusLineY').attr('y1', y).attr('y2', y)                        

              this.focus2.style('display', null)   
              this.focus2.select('#focus2Circle').attr('cx', x).attr('cy', y2)
              this.focus2.select('#focus2LineX').attr('x1', x).attr('x2', x)
              this.focus2.select('#focus2LineY').attr('y1', y2).attr('y2', y2)                        
            }            
          }
          else{             
            this.focus.style('display', 'none')   
            this.focus2.style('display', 'none')   
          }
        }

        
      },
      refreshGraphCache(newValue) {        
        this.doRefreshGraphCache()        
      },
    },
    mounted() {
      this.accuracy = 4
      this.canDrawGraph = false           
        if(this.$refs.canvasLines) {
          this.contextLines = this.$refs.canvasLines.getContext('2d')    
          this.contextPoints = this.$refs.canvasPoints.getContext('2d')    
          this.contextSelectedLines = this.$refs.canvasSelectedLines.getContext('2d')    
          this.contextSelectedPoints = this.$refs.canvasSelectedPoints.getContext('2d')            
          this.contextSelectedShape = this.$refs.canvasSelectedShape.getContext('2d')    
          this.canvasColor = document.createElement('canvas')
        }

        //recuperation de l'instance du SVG
        this.svg = d3.select(`#svgnav_${this.safe_prefixe}${this.uiid}`)
                    .append("g")        

        if(!this.graphHoverMode) {
                            
          //creation des fonctions de creation des axes x
          this.xTopAxis = d3.axisTop(this.scale.x)
          this.xAxis = d3.axisBottom(this.scale.x)        

          //creation de la fonction de creation axe y
          this.yAxis = d3.axisLeft(this.scale.y)
          
          
          //creation de la fonction de creation du color axis
          this.colorAxis = d3.axisRight(this.scale.cv)
          //application du nombre de tick color
          if(this.colorTicks > 0) {
            this.colorAxis.ticks(this.colorTicks)        
          }

          //creation des fonctions de creation des grilles X et Y
          this.xGrid = d3.axisBottom(this.scale.x).tickFormat("")
          this.yGrid = d3.axisLeft(this.scale.y).tickFormat("")

          // application du nombre de tick X
          if(this.xTicks > 0){
            this.xTopAxis.ticks(this.xTicks)
            this.xAxis.ticks(this.xTicks)
            this.xGrid.ticks(this.xTicks)
          }

          //application du nombre de tick Y
          if(this.yTicks > 0) {
            this.yAxis.ticks(this.yTicks)
            this.yGrid.ticks(this.yTicks)
          }
        
                              
            
          //Ajout de l'objet Abscisse Axis au svg
          this.gxAxis = this.svg.append("g")
                .attr("class", "x axis")                
          //Ajout de la legend Abscisse Axis au svg
          this.gxText = this.gxAxis.append("text")
                            .attr("class", "legendTitle")                                                    
                            .style("text-anchor", "middle")
                            .text("X Axis")

          //Ajout de l'objet Ordonnée Axis au svg
          this.gyAxis = this.svg.append("g")
                .attr("class", "y axis")                 
          //Ajout de la legend Ordonnée Axis au svg
          this.gyText = this.gyAxis.append("text")
                      .attr("class", "legendTitle")
                      .attr("transform", "rotate(-90)")                    
                      .attr("y", -(this.offsetLegendY + this.axisWidthY))
                      .style("text-anchor", "middle")
                      .text("Y Axis")                         
          
          //Ajout de l'objet Color Axis au svg
          this.gColorAxis = this.svg.append("g")
                .attr("class", "color axis")    
          //Ajout de la legend Color Axis au svg
          this.gColorText = this.gColorAxis.append("text")
                      .attr("class", "legendTitle")
                      .attr("transform", "rotate(-90)")                                        
                      .style("text-anchor", "middle")
                      .attr("y", -(this.colorGradientWidth + this.offsetLegendColor))
                      .text("Color Axis")           

          //Ajout des objets grilles au svg
          this.gxGrid = this.svg.append("g")
                .attr("class", "grid")                 
          this.gyGrid = this.svg.append("g")
                .attr("class", "grid")         

          //Ajout des objets de line de tracking au svg
          this.focus = this.svg.append('g').style('display', 'none')
          //ajout de la line tracking X au svg   
          this.focus.append('line')
                  .attr('id', 'focusLineX')
                  .attr('class', 'focusLine')
                  .attr('y1', this.svgHeight)
                  .attr('y2', 0)
          //ajout de la line de tracking Y au svg   
          this.focus.append('line')
                  .attr('id', 'focusLineY')
                  .attr('class', 'focusLine')
                  .attr('x1', 0)
                  .attr('x2', this.svgWidth)                
          //ajout du cercle de focus au svg
          this.focus.append('circle')
                  .attr('id', 'focusCircle')
                  .attr('r', 3)
                  .attr('class', 'circle focusCircle');   
                  
          this.focus2 = this.svg.append('g').style('display', 'none')
          //ajout de la line tracking X au svg   
          this.focus2.append('line')
                  .attr('id', 'focus2LineX')
                  .attr('class', 'focusLine')
                  .attr('y1', this.svgHeight)
                  .attr('y2', 0)
          //ajout de la line de tracking Y au svg   
          this.focus2.append('line')
                  .attr('id', 'focus2LineY')
                  .attr('class', 'focusLine')
                  .attr('x1', 0)
                  .attr('x2', this.svgWidth)                
          //ajout du cercle de focus au svg
          this.focus2.append('circle')
                  .attr('id', 'focus2Circle')
                  .attr('r', 3)
                  .attr('class', 'circle focusCircle');       
      }
      
            
      //ajout de l'overlay pour gestion des events au svg
      this.overlay =  this.svg.append('rect')
          .attr('class', 'overlay')                       
          .on('mouseout', () => {
            //Supprime le point tracké
            this.setHoverData(null)
            // if (this.animationID != null) {
            //   cancelAnimationFrame( this.animationID )
            //   this.animationID = null
            // }
          })     
          // -- WEBGL - Ecouteur sur le deplacement de la souris pour trouver le point le plus proche
          .on("pointermove", () => {
            // -- Webgl --pointer        
            if(this.canMovePointer) {                             
              this.canMovePointer = false              
              var e = d3.event
              const mouse = d3.mouse(d3.event.target)    
              this.pointer.x = mouse[0]  / this.svgWidth * 2 -1 
              this.pointer.y = -mouse[1] / this.svgHeight * 2 + 1
              this.webgl_pointerScale()   
              this.webgl_compute_nearest()
              this.renderer.render(this.scene, this.camera)                   
              setTimeout(()=>{                
                this.canMovePointer = true
                },this.refreshEveryMs)
            }
          })
          // .on('pointerover',()=>{
          //   if (this.animationID == null) this.animate()
          // })

          if(this.allowZoom && !this.graphHoverMode) {
            
            this.overlay.on('mousedown', () => {              
              //masque le tracking sur mouse down (si le mode zoom est actif)
              this.focus.style('display', 'none')              
              
              if (this.keyShiftPressed) {                
                d3.event.stopPropagation();
                let zoomRect = this.keyShiftPressed
                let e = d3.event.target,
                origin = d3.mouse(e),
                rect = this.svg.append("rect").attr("class", "zoom")
                d3.select("body").classed("noselect", true)
                origin[0] = Math.max(0, Math.min(this.svgWidth, origin[0]))
                origin[1] = Math.max(0, Math.min(this.svgHeight, origin[1]))
                d3.select(window)
                  .on("mousemove.zoomRect", () => {
                      let m = d3.mouse(e)
                      m[0] = Math.max(0, Math.min(this.svgWidth, m[0]))
                      m[1] = Math.max(0, Math.min(this.svgHeight, m[1]))
                      rect.attr("x", Math.min(origin[0], m[0]))
                          .attr("y", Math.min(origin[1], m[1]))
                          .attr("width", Math.abs(m[0] - origin[0]))
                          .attr("height", Math.abs(m[1] - origin[1]))
                  })
                  .on("mouseup.zoomRect", () => {
                      d3.select(window).on("mousemove.zoomRect", null).on("mouseup.zoomRect", null)
                      d3.select("body").classed("noselect", false)
                      let m = d3.mouse(e)
                      m[0] = Math.max(0, Math.min(this.svgWidth, m[0]))
                      m[1] = Math.max(0, Math.min(this.svgHeight, m[1]))
                      if (m[0] !== origin[0] && m[1] !== origin[1]) {
                        const sortNumber = (a,b) => a-b
                        this.zoomDomainX = [origin[0], m[0]].sort(sortNumber).map(this.zoomScale.x.invert)
                        this.zoomDomainY = (this.invertedOrdonnee?[origin[1], m[1]].sort(sortNumber):[origin[1], m[1]].sort(sortNumber).reverse()).map(this.zoomScale.y.invert)                        
                        //recalcul du facteur de zoom que l'on peut appliquer
                        const fact = Math.min (this.domainZoomFact.x,this.domainZoomFact.y)                                                
                        this.zoom_function.scaleExtent([fact, 100000 * fact])

                        //reset le zoom global on repart sur l'identity car on a reduit le domain avec le rectangle
                        this.$store.myActions.UI_SET_GRA_TRANSFORM({uiid:this.uiid,transform:d3.zoomIdentity})
                         d3.select(`#contnav_${this.safe_prefixe}${this.uiid}`)       
                            .call(this.zoom_function.transform,this.transform)
                      }
                      rect.remove()
                      this.drawGraph()                      
                    }, true)                              
              }
              return false;              
            })            
          }            
          if(this.allowClick && !this.graphHoverMode) {
            this.overlay.on('click', () => {              
              //cherche le yo correspondant au point tracké 
              const index = this.mission.yoArray.findIndex(yo => yo.yosCycle == this.hoverData.yosCycle)
              if(index > -1) {
                //si yo trouvé on le selectionne
                this.$store.myActions.UI_SELECT_TIMELINE_MISSION_INDEX({                    
                  index, 
                  uiid:this.missionUiid})
                  this.alert = false
              }
              else{
                this.alert = true
              }
            })
          }                                
      
      if(!this.graphHoverMode)
      {
        //construction du gradiant pour la légende      
        //ajout de la definition du gradient au svg                               
        this.colorGradient = this.svg.append("defs")
                .append("linearGradient")
                .attr("id", `${this.safe_prefixe}${this.uiid}-legend-color`)
                .attr("x1", "0%").attr("y1", "100%")
                .attr("x2", "0%").attr("y2", "0%")
        
        const scaleColor = d3.scaleLinear()
                .domain([0,5,10])              
                .range([this.colorMin, this.colorMid, this.colorMax])                
                .interpolate(d3.interpolateHcl)   

        this.colorGradient.selectAll("stop")       
                .data(d3.range(11))               
                .enter()
                .append("stop")                             
                .attr("offset",   d => { return d/10.0 })   
                .attr("stop-color", d => { return scaleColor(d) })

        //ajoute l'objet wrapper de legende de couleur au svg
        this.colorLegend = this.svg.append("g")
                                .attr("class", "legendWrapper")
        //Ajoute le dessin de la légende avec le dégradé  
        this.colorLegendRect = this.colorLegend.append("rect")
                        .attr("class", "legendRect")
                        .attr("x", 0)
                        .attr("y", 0)
                        .attr("rx", this.colorGradientWidth / 2)
                        .attr("width", this.colorGradientWidth )
                        .style("fill", `url(#${this.safe_prefixe}${this.uiid}-legend-color)`)        
        
        //fonction de gestion du zoom et pan
        if(this.allowZoom) {        
          var that = this
          //construction de la fonction d'interaction zoom et pan           
          this.zoom_function = d3.zoom()
          .scaleExtent([1, 100000])                                     
          .on('zoom', () => {
            if(this.canPanOrZoom){
              this.canPanOrZoom = false                        
              const event = d3.event
              // -- JO
              this.$store.myActions.UI_SET_GRA_TRANSFORM({uiid:this.uiid,transform:d3.event.transform})                                   
              this.drawGraph()      
              setTimeout(()=>{
                this.canPanOrZoom = true
              },this.refreshEveryMs)
            }        
          })                                     
          
          d3.select(`#contnav_${this.safe_prefixe}${this.uiid}`)
          //on atache les listener au container
            .call(this.zoom_function)  
          //reafecte la transformation courante au container  
            .call(this.zoom_function.transform,this.transform)
                                                                   
          
        }      
        
        if(this.useCacheImg){
          if(this.forceGenereCache) this.doRefreshGraphCache()
          else this.updateImageUrl() 
        }         
      }
      //lance la fonction de positionnement des objets svg en fonction de la taille de la fenetre      
      this.updateSize()
      this.isRender = true
      this.$nextTick(()=>{
        this.webgl_init()      
      }) 
      setTimeout(()=> this.updateSize(),1000)
    },
    methods: {
      webgl_update(){
        if (this.camera){
          const posx1 = this.allowZoom && this.zoomVariable != "ZoomYAxis"?-this.transform.x / this.transform.k:0
          const posx2 = this.allowZoom && this.zoomVariable != "ZoomYAxis"?posx1 + this.svgWidth / this.transform.k : this.svgWidth
          const posy1 = this.allowZoom && this.zoomVariable != "ZoomXAxis"?this.transform.y / this.transform.k:0
          const posy2 = this.allowZoom && this.zoomVariable != "ZoomXAxis"? posy1 - this.svgHeight / this.transform.k:-this.svgHeight

          this.camera.left =  posx1
          this.camera.right = posx2
          this.camera.top = posy1
          this.camera.bottom = posy2

          let i = 0
          let len = this.webgl_transform_ref.length
          while (i< len && this.transform.k > this.webgl_transform_ref[i]){
            i++
          }

          if (this.transform.k <= this.webgl_transform_ref[i])
            this.accuracy = this.webgl_accuracies[i]
          else {
            this.accuracy = 0.007
          }

            // if (this.transform.k == 1){
            //   this.accuracy = 4
            // }
            // else if (this.transform.k < 10){
            //   this.accuracy = 1
            // }
            // else if (this.transform.k < 25){
            //   this.accuracy = 0.75
            // }
            // else if (this.transform.k < 50){
            //   this.accuracy = 0.5
            // }
            // else if (this.transform.k < 75){
            //   this.accuracy = 0.25
            // }
            // else if (this.transform.k < 100){
            //   this.accuracy = 0.1
            // }
            // else if (this.transform.k < 200){
            //   this.accuracy = 0.05
            // }
            // else if (this.transform.k < 500){
            //   this.accuracy = 0.01
            // }
            // else {
            //   this.accuracy = 0.007
            // }
            this.rayCaster.params.Points.threshold = this.accuracy //+ 1/this.transform.k  
            for (i = 0; i< this.nRays; i++){
              this.rayCasters[i].params.Points.threshold = this.accuracy/(i+1)
              // this.rayThresholds[i] = 3*(i+1)*this.accuracy
              this.rayThresholds[i] = Math.exp(i+1)*this.accuracy
              this.rayCasters2[i].params.Points.threshold = this.rayThresholds[i]
            }           
            this.camera.updateProjectionMatrix()
            this.renderer.render(this.scene, this.camera) 
        }
      },

      webgl_pointerScale(){
        if(this.pointer && this.camera && this.pointer3d && this.plane){
          this.rayCaster.setFromCamera( this.pointer, this.camera)
          this.rayCaster.ray.intersectPlane( this.plane, this.pointer3d)
          this.worldPointer3d.copy(this.pointer3d)
          this.worldPointer2d.set(this.pointer3d.x, this.pointer3d.y)
        }
      },

      webgl_compute_nearest(){
  
          let j = 0
          this.intersection = []
          while (j < this.nRays && this.intersection.length < 1){
            this.intersection = []
            this.rayCasters2[j].setFromCamera(this.pointer, this.camera)
            this.intersection = this.rayCasters2[j].intersectObject(this.points, true)
            j++
          }
          if (this.intersection.length > 0){
            let minDistance = Infinity
            let indexMin = -1
            for (var i =0; i<this.intersection.length; i++){
              let index = this.intersection[i].index
              let point = new THREE.Vector2(this.vertices[3*index], this.vertices[3*index+1])
              let distance = this.worldPointer2d.distanceToSquared(point)
                       
              if (distance < minDistance){
                minDistance = distance
                indexMin = index
              }
            }
            const ordonnes = this.ordonneePlotvariable.variables?this.ordonneePlotvariable.variables:[this.ordonneeVariable]
            const nbGraph = ordonnes.length            
            //console.log(indexMin.toString(),this.datas.length,this.vertices)                        

            indexMin = indexMin>-1?(indexMin%(this.vertices.length / (3*nbGraph))):-1                                          
            this.setHoverData((indexMin > -1)? this.datasToDraw[indexMin] : null )
          }
      },

      webgl_build_figure(){
        if(this.svgWidth > 0 && this.svgHeight > 0 && this.abscissePlotvariable) {                           
          this.renderer.setSize(this.svgWidth, this.svgHeight)          
          const hasColorVariable = this.colorVariable != "None"
          const xArray = this.datasToDraw.map(d => d[this.abscissePlotvariable.variable])          
          var cArray = hasColorVariable?this.datasToDraw.map(d => d[this.colorPlotvariable.variable]): []
          
          this.vertices = []
          this.colors = []        
          
          const ordonneeToPlot = this.ordonneePlotvariable.variables?this.ordonneePlotvariable.variables:[this.ordonneeVariable]                  
          ordonneeToPlot.forEach((v,idx) => {    
            // console.log(v)
            const verticesLine = []
            const colorsLine = []

            var yArray = this.datasToDraw.map(d => d[v])
            let color = undefined      
            //on recupere les couleur a appliquer   
            if(this.abscissePlotvariable.typeData == "date") {
              if(this.ordonneePlotvariable.colors && this.ordonneePlotvariable.colors.length > idx) color = this.ordonneePlotvariable.colors[idx]            
            }
            else{
              if(this.abscissePlotvariable.colors && this.abscissePlotvariable.colors.length > idx) color = this.abscissePlotvariable.colors[idx]            
            }          
            color = color || GRAPHS_COLORS[idx] || this.$vuetify.theme.secondary                
            
            
            for (var i =0; i<xArray.length; i++) {

              const vertice = [this.scale.x(xArray[i]),-this.scale.y(yArray[i]),10]
              this.vertices.push(...vertice)
              
              if(hasColorVariable){              
                //on borne la valeur de couleur dans le domaine
                color = this.scale.c(Math.min(this.domains.c[2],Math.max(this.domains.c[0], cArray[i])))
              }        
              const colorT = new THREE.Color(color)              
              this.colors.push(colorT.r, colorT.g, colorT.b)
              if(!this.sciGraph){
                  verticesLine.push(...vertice)
                  colorsLine.push(colorT.r, colorT.g, colorT.b)
              }
            }
            
            
            // -- WEBGL - Ajout de ligne: 1 seule ligne reliant les vertices dans l'ordre
            if (!this.sciGraph){              
              const lineGeometry = new THREE.BufferGeometry()
              lineGeometry.setAttribute('position', new THREE.Float32BufferAttribute(verticesLine, 3))
              lineGeometry.setAttribute('color', new THREE.Float32BufferAttribute(colorsLine, 3))              
              this.scene.add(new THREE.Line(lineGeometry, this.lineMaterial))
            }
            
          })          

          this.bufferGeometry.setAttribute('position', new THREE.Float32BufferAttribute(this.vertices, 3))
          this.bufferGeometry.setAttribute('color', new THREE.Float32BufferAttribute(this.colors, 3 ))
          

          // -- WEBGL - Generic design parameters for Points
          this.pointsMaterial = new THREE.PointsMaterial({
              size: this.pointSize * (this.sciGraph?1:2) ,
              // transparent: true,
              sizeAttenuation: false,
              vertexColors: true // Tells webgl that we are using a color per vertex
          })
          
          this.points = new THREE.Points(this.bufferGeometry, this.pointsMaterial)          
          this.pointsContainer = new THREE.Object3D()
          this.pointsContainer.add(this.points)
          this.scene.add(this.pointsContainer)
          // -- WEBGL - Camera --          
          this.camera = new THREE.OrthographicCamera(0, this.svgWidth,0, -this.svgHeight, this.near, this.far );
          this.camera.position.set(0, 0, this.far)                  
          
          this.scene.add(this.camera)
          

          // -- WEBGL - Controls
          this.hasControls = false
          if (this.hasControls){
            this.controls = new OrbitControls( this.camera, this.container)
            this.controls.enableRotate = false
            this.controls.enablePan = false
            this.controls.enableZoom = true
            this.controls.zoomSpeed = 2
            this.controls.maxZoom = this.far
            this.controls.minZoom = 0
            this.controls.mouseButtons = {MIDDLE: THREE.MOUSE.DOLLY, LEFT: THREE.MOUSE.PAN}
            this.controls.enableDamping = true
            this.controls.dampingFactor = 0.3
            this.controls.update()
          }

          // -- WEBGL - animate 
          this.webgl_zoom = this.transform.k
          // if(this.graphHoverMode) this.animate()
          // else this.renderer.render(this.scene, this.camera)            
                    
          this.webgl_update()
        }
        else{
          setTimeout(() => {
            this.webgl_build_figure()
          }, 200);
        }
      },

      webgl_rebuild(){                     
          this.webgl_clearRender()
          //STEPH
          //Refait le init corrige le bug de disparition des points pourquoi????? je ne sais pas
          this.webgl_init()
          this.webgl_build_figure()
			},

      webgl_clearRender(){        
        // cancelAnimationFrame( this.animationID )
        if (this.scene){
            while(this.scene.children.length > 0){
              this.scene.remove(this.scene.children[0]);
            }
            this.renderer.dispose()
          }
        },

      webgl_init(){
        // -- WEBGL -  ThreeJS Initialisation
        this.container = this.$refs.graphs        
        this.renderer = new THREE.WebGLRenderer({canvas: this.$refs.canvasPointsGl, antialias: !this.sciGraph})  
        // this.renderer = new THREE.WebGLRenderer({canvas: this.$refs.canvasPointsGl, antialias: true})        
        this.contextPointsGl =  this.renderer.getContext()    
        this.renderer.setClearColor( "white", 1)
        this.scene = new THREE.Scene()

        // -- WEBGL - Data 
        this.bufferGeometry = new THREE.BufferGeometry()
        this.pointsContainer = new THREE.Object3D()
        this.colors = []
        this.vertices = []

        // WEBGL - Lignes reliant les points dans les graphes de navigation        
        this.lineMaterial = new THREE.LineBasicMaterial({vertexColors: true, linewidth: 0.1})
        
        this.pointer = new THREE.Vector2(); 
        this.pointerColor = 0x000000
        
        this.webgl_transform_ref = [1, 10, 25, 50, 75, 100, 200, 500]
        this.webgl_accuracies =  [4, 1, 0.75, 0.5, 0.25, 0.1, 0.05, 0.01] 
        this.rayThresholds = []
        this.rayCasters = []
        this.rayCasters2 = []
        this.nRays = 6
        for (var i = 0; i < this.nRays; i++){
          this.rayCasters[i] = new THREE.Raycaster()
          this.rayCasters2[i] = new THREE.Raycaster()
          this.rayCasters[i].params.Points.threshold = this.accuracy * 1/(i+1)          
          this.rayThresholds[i] = Math.exp(i+1)*this.accuracy
          this.rayCasters2[i].params.Points.threshold = this.rayThresholds[i]
        }
        this.rayCaster = new THREE.Raycaster()
        this.rayCaster.params.Points.threshold = this.accuracy 
           
        this.plane = new THREE.Plane( new THREE.Vector3( 0, 0, 10 ), 0 )        

        this.worldPointer3d = new THREE.Vector3()
        this.worldPointer2d = new THREE.Vector2()
        this.pointer3d = new THREE.Vector3()
        this.pointer2d = new THREE.Vector2()


      },

      scaleValue(domain, range){
        return d3.scaleLinear()
          .domain(domain)
          .range(range)
          .nice()
        },

       // -- WEBGL - Three.js render loop
      // animate() {       
      //    console.log("Animate") 
      //     if (this.animationID != null) {
      //       cancelAnimationFrame( this.animationID )
      //     }
      //     this.animationID = requestAnimationFrame(this.animate)        
      //     // -- WEBGL - Raycast - Hover data
      //     this.webgl_compute_nearest()
          
      //     this.renderer.render(this.scene, this.camera)        
      // },    


      doRefreshGraphCache(){
        if(this.useCacheImg && (
              !this.importedCsvHeaders || 
              this.importedCsvHeaders.length  == 0 ||               
              this.importedCsvHeaders.indexOf(this.mainVariable) > -1            
            ))
        {          
          this.loading = true                              
          setTimeout(() => {                      
            //if(window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`] && window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`][this.imgName]) delete window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`][this.imgName]
            this.imagecache = null
            this.contextLines.canvas.height = IMAGE_CACHE_HEIGHT
            this.contextLines.canvas.width = IMAGE_CACHE_WIDTH
            this.contextPoints.canvas.height = IMAGE_CACHE_HEIGHT
            this.contextPoints.canvas.width = IMAGE_CACHE_WIDTH
            this.contextPointsGl.canvas.height = IMAGE_CACHE_HEIGHT
            this.contextPointsGl.canvas.width = IMAGE_CACHE_WIDTH
            this.genereCache = true
            this.drawGraph()
          }, 500)
        }
      },
      tryTranslate(key) {
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      setHoverData(hoverData) {
        if(this.sciGraph) {
           this.$store.myActions.UI_SET_SCI_HOVERDATA({uiid:this.missionUiid, hoverData})
        }
        else if(this.simuGraph) {
           this.$store.myActions.UI_SET_SIMU_HOVERDATA({uiid:this.missionUiid, hoverData})
        }
        else{          
          this.$store.myActions.UI_SET_NAV_HOVERDATA({uiid:this.missionUiid, hoverData})
        }
      },
      updateImageUrl() {        
       // if(!window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`] || !window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`][this.imgName]) {                       
          //met en cache l'image dans la fenetre du navigateur          
         // if(!window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`]) window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`] = {}        
          
          const imagecache =  new Image()       
          this.imagecache = imagecache   
          const that = this       
          this.imagecache.onload = function() {
            imagecache.ready = true                        
           // window[`imgcache_${that.mission.misId}_${that.sciGraph?"sci":this.simuGraph?"simu":"nav"}`][that.imgName] = imagecache
            that.drawGraph()      
          }                                          
          this.imagecache.ready = false
          apiMission.getImageMission(this.imgName)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            this.imagecache.src = url            
          }).catch((error) => {                       
            if(!error.response) return
            if(error.response.status == 401) {                                 
              this.isAllowed = false
            }
            if(error.response.status == 404) {
              //l'image n'existe pas on demande la creation
              this.contextLines.canvas.height = IMAGE_CACHE_HEIGHT
              this.contextLines.canvas.width = IMAGE_CACHE_WIDTH
              this.contextPoints.canvas.height = IMAGE_CACHE_HEIGHT
              this.contextPoints.canvas.width = IMAGE_CACHE_WIDTH
              this.contextPointsGl.canvas.height = IMAGE_CACHE_HEIGHT
              this.contextPointsGl.canvas.width = IMAGE_CACHE_WIDTH              
              this.genereCache = true
            }                        
          }) 
       /* }
        else {            
          this.imagecache = window[`imgcache_${this.mission.misId}_${this.sciGraph?"sci":this.simuGraph?"simu":"nav"}`][this.imgName]                                
          this.drawGraph()
        }*/        
      },
      updateSize() {        
        
        //laisse le temps au navigateur d'avoir les bonnes dimensions sur les zones             
        //console.log("updateSize start")
        if(this.updateSizeId) clearTimeout(this.updateSizeId)
        this.updateSizeId = setTimeout(() => { 
           //evite le resize sur element invisible
          if(this.$refs.container && this.$refs.container.parentElement && this.$refs.container.parentElement.clientHeight > 0) {                    
            this.canDrawGraph = false                       
            
            //masquer les rendu afin de pouvoir trouver la taille reelle
            this.$refs.graphs.style.display='none'       
                                
            //recupere la taille réelle du container
            this.width = this.$refs.container.parentElement.clientWidth
            this.height = this.$refs.container.parentElement.clientHeight
            this.$refs.graphs.style.display=null            
            //met a jour les position des objets svg
            this.updateSvgPosition()    
            //redimensionne la hauteur du canvas la largeur est redimensionné dans le updateSvgPosition
            this.contextLines.canvas.height = this.svgHeight
            this.contextPoints.canvas.height = this.svgHeight
            this.contextPointsGl.canvas.height = this.svgHeight
            this.contextSelectedLines.canvas.height = this.svgHeight
            this.contextSelectedPoints.canvas.height = this.svgHeight            
            this.contextSelectedShape.canvas.height = this.svgHeight
            //dessine le graphe   
            this.canDrawGraph = true
            this.webgl_rebuild()       
            this.drawGraph()
                                
          }                      
        },40) 
      },
      updateSvgPosition() {
        if(this.svgWidth > 0) {
          if(!this.graphHoverMode){
            //console.log("updateSvgPosition")
            //positionne la reference du svg (haut a gauche du canvas)
            this.svg.attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")")
            //dimensionne les lignes de tracking
            this.focus.select('#focusLineX').attr('y1', this.svgHeight) 
            this.focus.select('#focusLineY').attr('x2', this.svgWidth)
            //positionne la ligne grille X
            this.gxGrid.attr("transform", "translate("+[0, this.svgHeight]+")") 
            //positionne l'axe des X
            this.gxAxis.attr("transform", "translate("+[0, this.invertedOrdonnee?0:this.svgHeight]+")")  
            //positionne l'axe des couleurs
            this.gColorAxis.attr("transform", "translate("+[this.svgWidth + this.offsetLegendColor + this.defaultLineHeight + this.offsetLegendColor + this.colorGradientWidth, 0]+")")    
            //dimensionne la legende des couleurs
            this.colorLegendRect.attr("height", this.svgHeight)
            //positionne la legende des couleurs
            this.colorLegend.attr("transform", "translate(" + [this.svgWidth + this.offsetLegendColor + this.defaultLineHeight + this.offsetLegendColor]  + ")")
            //positionne la legend X
            this.gxText.attr("x",this.svgWidth/2).attr("y", this.invertedOrdonnee?-(this.offsetLegendX + this.axisHeightX):this.offsetLegendX + this.axisHeightX)
            //positionne la legend Y
            this.gyText.attr("x",-this.svgHeight/2)
            //positionne la legend color
            this.gColorText.attr("x",-this.svgHeight/2)          
          }

          //redimensionne la largeur du canvas
          this.contextLines.canvas.width = this.svgWidth //attention cela reset le canvas
          this.contextPoints.canvas.width = this.svgWidth //attention cela reset le canvas
          this.contextPointsGl.canvas.width = this.svgWidth
          this.contextSelectedLines.canvas.width = this.svgWidth //attention cela reset le canvas
          this.contextSelectedPoints.canvas.width = this.svgWidth //attention cela reset le canvas          
          this.contextSelectedShape.canvas.width = this.svgWidth //attention cela reset le canvas
          //dimensionne l'overlay
          this.overlay.attr('width', this.svgWidth).attr('height', this.svgHeight)                             
        }
      },
      refresh() {                             
         if(this.allowZoom) {
           this.zoomDomainX = undefined
           this.zoomDomainY = undefined
           this.zoom_function.scaleExtent([1, 100000])
           d3.select(`#contnav_${this.safe_prefixe}${this.uiid}`).call(this.zoom_function.transform, d3.zoomIdentity)                 
         }
      }, 
      drawGraph() {
        if(this.canDrawGraph) {      
          if(!this.graphHoverMode)    {
            //bloque draw graph il sera debloqué au nextTick permet de ne se rafraichir qu'une fois meme si plusieurs variables sont modifiées
            this.canDrawGraph = false          
            //console.log("drawGraph")
            
            ////////////////////////////
            //1 on met à jour la partie svg
            this.xAxis.scale(this.zoomScale.x)
            this.xTopAxis.scale(this.zoomScale.x)
            this.yAxis.scale(this.zoomScale.y)
            this.colorAxis.scale(this.scale.cv)

            this.xGrid.tickSize(-this.svgHeight)
            this.yGrid.tickSize(-this.svgWidth) 

            this.xGrid.scale(this.zoomScale.x)
            this.yGrid.scale(this.zoomScale.y)
          
            this.gxAxis.call(this.invertedOrdonnee?this.xTopAxis:this.xAxis)          

            this.gyAxis.call(this.yAxis)        
            this.gColorAxis.call(this.colorAxis)
          
            this.gxGrid.call(this.xGrid)
                              
            this.gyGrid.call(this.yGrid)                      
                    
            this.gColorAxis.style('display', this.colorVariable == 'None'?'none':null)
                
            this.colorLegend.style('display', this.colorVariable == 'None'?'none':null)  
            
            const complementLimite = this.useCacheImg?'': ` - ${this.$t(`Pilot.Graphics.LimitData${this.dataLimit}`)}`
            this.gxText.text(this.abscissePlotvariable?
                                    (this.abscissePlotvariable.unit?
                                      `${this.tryTranslate(this.abscissePlotvariable.name)} (${this.abscissePlotvariable.unit})${complementLimite}`
                                      :`${this.tryTranslate(this.abscissePlotvariable.name)}${complementLimite}`)
                                    :'')

            let yText = ''
            if(this.ordonneePlotvariable) {
              yText = this.ordonneePlotvariable.unit?`${this.tryTranslate(this.ordonneePlotvariable.name)} (${this.ordonneePlotvariable.unit})`:this.tryTranslate(this.ordonneePlotvariable.name)
              if(this.ordonneePlotvariable.infosVariables){
                yText += " -"
                this.ordonneePlotvariable.infosVariables.forEach((legend,index) => {
                  let legendText = this.tryTranslate(legend)
                  if(this.useCacheImg && legendText.length > 3) legendText = `${legendText.substring(0,3)}.`
                  yText += `&nbsp;&nbsp;&nbsp;<tspan stroke-width="0.5" stroke="${GRAPHS_COLORS[index]}">${legendText}</tspan>`
                })
              }
            }
            this.gyText.html(yText)
            
            this.gColorText
                .text(this.colorPlotvariable?(this.colorPlotvariable.unit?`${this.tryTranslate(this.colorPlotvariable.name)} (${this.colorPlotvariable.unit})`:this.tryTranslate(this.colorPlotvariable.name)):'')
                .style('display', this.colorVariable == 'None'?'none':'block')  
            
              
            //met à jour le gradient de couleur
            const scaleColor = d3.scaleLinear()
                .domain([0,5,10])                
                .range([this.colorMin, this.colorMid, this.colorMax])                
                .interpolate(d3.interpolateHcl)   

            this.colorGradient.selectAll("stop")       
                    .data(d3.range(11))                                                                                
                    .attr("stop-color", d => { return scaleColor(d) })

            ////////////////////////////
            //2 On reset le canvas           
            this.contextLines.clearRect(0, 0, this.svgWidth, this.svgHeight)
            this.contextPoints.clearRect(0, 0, this.svgWidth, this.svgHeight)
            this.contextSelectedLines.clearRect(0, 0, this.svgWidth, this.svgHeight)
            this.contextSelectedPoints.clearRect(0, 0, this.svgWidth, this.svgHeight)          
            this.contextSelectedShape.clearRect(0, 0, this.svgWidth, this.svgHeight)  
            if(this.genereCache) {            
              this.contextLines.fillStyle = "#ffffff"
              this.contextLines.fillRect(0, 0, this.svgWidth, this.svgHeight)                      
            }

          }
          //si on n'utilise pas le cache image alors on dessine les points
          if(!this.useCacheImg || this.genereCache) {
            this.webgl_update()
            //si on utilise voronoi on realise son rendu
            if(this.useVoronoi && this.colorVariable != "None"){
             /* const particles = this.datas.map(d => [this.zoomScale.x(d[this.abscisseVariable]),this.zoomScale.y(d[this.ordonneeVariable])])
              const delaunay = new Delaunay.from(particles)
              const voronoi = delaunay.voronoi([0, 0, this.svgWidth, this.svgHeight])
              
              this.datas.forEach((data,i) => {
                this.contextPoints.beginPath()
                voronoi.renderCell(i,this.contextPoints)    
                let dataColor = data[this.colorVariable]                
                if(dataColor < this.domains.c[0]) dataColor = this.domains.c[0]
                if(dataColor > this.domains.c[2]) dataColor = this.domains.c[2]                
                const color = this.scale.c(dataColor)
                this.contextPoints.fillStyle = color       
                this.contextPoints.strokeStyle = color  
                this.contextPoints.fill()                        
                this.contextPoints.stroke() 
                                          
              })                    
              //nettoie le canvas avec les valeur limites
              const xmin = this.zoomScale.x(this.missionDomains.x[0])
              const xmax = this.zoomScale.x(this.missionDomains.x[1])
              const ymin = this.zoomScale.y(this.missionDomains.y[0])
              const ymax = this.zoomScale.y(this.missionDomains.y[1])                
              
              if(ymin > 0 && ymin < this.svgHeight) this.contextPoints.clearRect(0, 0, this.svgWidth, ymin)
              if(ymax > 0 && ymax < this.svgHeight) this.contextPoints.clearRect(0, ymax, this.svgWidth, this.svgHeight - ymax)
              if(xmin > 0 && xmin < this.svgWidth) this.contextPoints.clearRect(0, 0, xmin, this.svgHeight)
              if(xmax > 0 && xmax < this.svgWidth) this.contextPoints.clearRect(xmax, 0, this.svgWidth - xmax, this.svgHeight)                
                
              //On rend les point seulement du cycle sélectionnée
              this.renderCanvas(true)*/
            } 
            else{
              // this.webgl_rebuild()
              if(!this.graphHoverMode) this.renderCanvas(true)
            }            
          }
          else {
                        
            //draw image from cache              
            if(this.imagecache && this.imagecache.ready) {
              this.contextPoints.drawImage(this.imagecache,0,0,this.svgWidth, this.svgHeight) // Or at whatever offset you like
              //On rend les point seulement du cycle sélectionnée
              this.renderCanvas(true)
            }                        
          }      
                            
          //met a jour le loading icon ici car l'observation du changement de ready sur imagecache ne fonctionne pas
          this.loading = !this.graphHoverMode && (this.isAllowed && this.useCacheImg && (!this.imagecache || !this.imagecache.ready))          

          if(!this.graphHoverMode) {
            this.$nextTick(() => {
              this.canDrawGraph = true
              if(this.genereCache) {
                //si on a generecache à true on fusionne les canvas et on sauvegarde le rendu
                this.contextLines.drawImage(this.contextPoints.canvas, 0, 0)                                                        
                const image = this.contextLines.canvas.toDataURL("image/jpeg",0.8).replace('data:image/jpeg;base64,', '')              
                this.contextPoints.clearRect(0, 0, IMAGE_CACHE_WIDTH, IMAGE_CACHE_HEIGHT)
                this.contextLines.clearRect(0, 0, IMAGE_CACHE_WIDTH, IMAGE_CACHE_HEIGHT)              
                this.genereCache = false              
                //savegarde l'image sur le serveur puis la recharge
                this.$store.myActions.MISSION_SAVE_IMAGE_REQUEST({imageData:image,name:this.imgName}).then(() => {
                  this.$emit("cached")
                  this.updateImageUrl()
                }).catch(() =>{
                  this.$emit("cacheFailed")
                })                               
              }
            }) 
          }         
        }      
      },   
      drawCurrentCycle(){
        this.contextSelectedLines.clearRect(0, 0, this.svgWidth, this.svgHeight)
        this.contextSelectedPoints.clearRect(0, 0, this.svgWidth, this.svgHeight)        
        this.contextSelectedShape.clearRect(0, 0, this.svgWidth, this.svgHeight)
        //On rend les point seulement du cycle sélectionnée
        this.renderCanvas(true)
      },
      renderCanvas(onlySelected) {   
        
        const hasColorVariable = this.colorVariable != "None"
        //calcul la taille des points
        let size = this.genereCache? (this.colorVariable != "None"?5:2) : this.pointSize
        size = size * Math.min(Math.max(1,(this.transform.k)/10),2)
        const ordonneeToPlot = this.ordonneePlotvariable.variables?this.ordonneePlotvariable.variables:[this.ordonneeVariable]
        
        const r = size / 2.0
        //preparation des points pour le rendu                
        if(hasColorVariable) {
          const n = this.svgHeight          
          this.canvasColor.width = n * size
          this.canvasColor.height = size
          const ctx = this.canvasColor.getContext('2d')
          for (var i = 0; i < n; ++i) { 
              ctx.fillStyle = this.scale.c(this.scale.cv.invert(i))
              ctx.beginPath()
              ctx.rect(i * size, 0, size, size)              
              //ctx.arc(i * size + r, r, r, 0, 2 * Math.PI)
              ctx.closePath()
              ctx.fill()
          }
        }
          
        const datas = onlySelected?this.datasToDraw.filter(d => d.yosCycle == this.currentCycle):this.datasToDraw
        ordonneeToPlot.forEach((v,idx) => {    
          let color = undefined      
          //on recupere les couleur a appliquer   
          if(this.abscissePlotvariable.typeData == "date") {
            if(this.ordonneePlotvariable.colors && this.ordonneePlotvariable.colors.length > idx) color = this.ordonneePlotvariable.colors[idx]            
          }
          else{
            if(this.abscissePlotvariable.colors && this.abscissePlotvariable.colors.length > idx) color = this.abscissePlotvariable.colors[idx]            
          }          
          color = color || GRAPHS_COLORS[idx] || this.$vuetify.theme.secondary                    
          //on configure les contexts et on commence les chemins de rendu
          this.contextSelectedShape.strokeStyle = "#333"
          this.contextSelectedShape.lineWidth  = 1

          if(!hasColorVariable){
            this.contextSelectedPoints.strokeStyle = color
            this.contextSelectedPoints.lineWidth  = size     
          }
          
          this.contextSelectedLines.strokeStyle =   "#333"
          this.contextSelectedLines.lineWidth  = 1
          
          if(!onlySelected){
            if(!hasColorVariable){
              this.contextPoints.strokeStyle = color
              this.contextPoints.lineWidth = size
              this.contextPoints.beginPath()
            }
            
            this.contextLines.strokeStyle = color
            this.contextLines.lineWidth  = 1            
            this.contextLines.beginPath()
          }           
                  
          if(!hasColorVariable) this.contextSelectedPoints.beginPath()
          this.contextSelectedLines.beginPath()
          //on ne commence pas de chemin sur contextSelectedShape car il n'y a pas stroke réalisés

          //on boucle sur les données     
          datas.forEach((data,index) => {  
            this.drawData(data,index,v,size,hasColorVariable,onlySelected,index>0?datas[index-1]:null)
          })                        

          //on dessine les chemins crees   
          if(!onlySelected){
            if(!hasColorVariable) this.contextPoints.stroke()
            this.contextLines.stroke()          
          }           
          if(!hasColorVariable) this.contextSelectedPoints.stroke()
          this.contextSelectedLines.stroke()
        })
      },
      drawData(data,index,ordonneeVariable, size,hasColorVariable,onlySelected,prevdata) {        
        //on ne dessine pas les points dont l'une des données est pas bonne
        if(mustIgnoreValue(data[ordonneeVariable],this.ordonneePlotvariable && this.ordonneePlotvariable.logarithmeAxis) || mustIgnoreValue(data[this.abscisseVariable],this.abscissePlotvariable && this.abscissePlotvariable.logarithmeAxis) || (hasColorVariable && mustIgnoreValue(data[this.colorVariable],this.colorPlotvariable && this.colorPlotvariable.logarithmeAxis))) return;
        //on regarde si on est sur le yo courant
        const isSelected = data.yosCycle == this.currentCycle
        const r = size /2.0
        const isInRange = (data.yosCycle>=this.currentRangeCycle[0] && data.yosCycle<=this.currentRangeCycle[1])
        //si la données est dans le range
        if(isSelected || isInRange) {          
          const px = this.zoomScale.x(data[this.abscisseVariable]) 
          const py = this.zoomScale.y(data[ordonneeVariable])                              
          let colorIdx = 0

          //si on a une echelle de couleur a appliquer on recupere la couleur correspondant                              
          if(hasColorVariable) {
            colorIdx = Math.max(0,Math.min(Math.floor(this.scale.cv(data[this.colorVariable])),this.svgHeight-1))            
          }            

          //dessine le point
          if(isInRange) {
            if(!onlySelected) {            
              if(hasColorVariable) {  
                this.contextPoints.drawImage(this.canvasColor, colorIdx * size, 0, size, size, px - r, py - r, size, size);
              }
              else{
                this.contextPoints.moveTo(px-(size/2),py)
                this.contextPoints.lineTo(px+(size/2),py)        
              }
            }                    
            else if(isSelected) {
              if(hasColorVariable) {  
                this.contextSelectedPoints.drawImage(this.canvasColor, colorIdx * size, 0, size, size, px - r, py - r, size, size);
              }
              else{
                this.contextSelectedPoints.moveTo(px-(size/2),py)
                this.contextSelectedPoints.lineTo(px+(size/2),py)    
              }                        
            }          
          }

          //dessine la ligne si graph de navigation
          if(!this.sciGraph || isSelected) {
            if(index > 0) {
              const px0 = this.zoomScale.x(prevdata[this.abscisseVariable]) 
              const py0 = this.zoomScale.y(prevdata[ordonneeVariable])    
              //dessine la ligne
              if(isSelected) { 
                if(!onlySelected) this.contextSelectedLines.moveTo(px0,py0)                
                this.contextSelectedLines.lineTo(px,py)
              } 
              if(!this.sciGraph) {
                this.contextLines.moveTo(px0,py0)
                this.contextLines.lineTo(px,py)
              }
            }            
            else if(onlySelected){
              if(isSelected) this.contextSelectedLines.moveTo(px,py)
              if(!this.sciGraph) this.contextLines.moveTo(px,py)
            }
          }

          //Dessine les point selectionnée et 
          if(isSelected) {
            //dessine le contour                         
            const useBlackRect = hasColorVariable || this.ordonneePlotvariable.variables || this.simuGraph
            if(!useBlackRect) {
              const up = index > 0 && data[this.sciGraph?this.mission.ySciProfileVariable:'Depth'] < prevdata[this.sciGraph?this.mission.ySciProfileVariable:'Depth']
              if(up) this.drawTriangleUp(2*size,px,py,useBlackRect)
              else this.drawTriangleDown(2*size,px,py,useBlackRect)
            } 
            else this.contextSelectedShape.strokeRect(px-(size/2),py-(size/2),size,size)
          }
        }        
      },
      drawTriangleUp(side, px, py,black = false) {
        //ctx, side, cx, cy)    
        var h = side * (Math.sqrt(3)/2);                
        this.contextSelectedShape.save();        
        if(!black) this.contextSelectedShape.strokeStyle="#009933"   
        this.contextSelectedShape.translate(px, py-2);  
        this.contextSelectedShape.beginPath();        
          this.contextSelectedShape.moveTo(0, -h / 2);
          this.contextSelectedShape.lineTo( -side / 2, h / 2);
          this.contextSelectedShape.lineTo(side / 2, h / 2);
          this.contextSelectedShape.lineTo(0, -h / 2);        
          this.contextSelectedShape.stroke();
        this.contextSelectedShape.closePath();
        this.contextSelectedShape.restore();
      },
      drawTriangleDown(side, px, py,black = false) {
        //ctx, side, cx, cy)    
        var h = side * (Math.sqrt(3)/2);                
        this.contextSelectedShape.save();
          if(!black) this.contextSelectedShape.strokeStyle="#cc0000"   
          this.contextSelectedShape.translate(px, py+2);  
          this.contextSelectedShape.beginPath();        
          this.contextSelectedShape.moveTo(0, h / 2);
          this.contextSelectedShape.lineTo( -side / 2, -h / 2);
          this.contextSelectedShape.lineTo(side / 2, -h / 2);
          this.contextSelectedShape.lineTo(0, h / 2);        
          this.contextSelectedShape.stroke();   
        this.contextSelectedShape.closePath();                
        this.contextSelectedShape.restore();
      },
      setHover(visible)
      {        
        this.$store.myActions.UI_SET_GRAPH_HOVER_DATA_VISIBILITY(visible)      
      }
    },
    beforeDestroy() {      
      if(this.overlay) {
        this.overlay.on('mouseout',null)
        this.overlay.on('pointermove',null)
        if(this.allowClick) this.overlay.on('click', null)
      }
      if(this.allowZoom) {
        d3.select(`#contnav_${this.safe_prefixe}${this.uiid}`).on(".zoom", null)
        if(this.overlay) this.overlay.on('mousedown', null)                  
      }
      //supprime les references
      this.imagecache = null
      this.t = null
      this.xTopAxis = null
      this.xAxis = null
      this.yAxis = null
      this.colorAxis = null
      this.xGrid = null
      this.yGrid = null
      this.gxAxis = null
      this.gxText = null
      this.gyAxis = null
      this.gyText = null
      this.gColorAxis = null
      this.gColorText = null
      this.overlay = null
      this.focus = null
      this.focus2 = null
      this.gxGrid = null
      this.gyGrid = null
      this.svg = null  
      this.colorLegend = null
      this.colorLegendRect = null
      this.context = null
      this.zoom_function = null
      this.alert = false            
    },
    beforeDestroy(){
     this.webgl_clearRender()   
    }
  }
</script>

<style>
.waiting{
  position: absolute;
  left:50%;
  top:50%;
  margin-left:-16px;
  margin-top:-16px;
}
  /* Style the lines by removing the fill and applying a stroke */
.line {
    fill: none;
    stroke: #ffab00;
    stroke-width: 3;
}
  
.overlay {
  fill: none;
  pointer-events: all;
}

/* Style the dots by assigning a fill and stroke */
.dot {
    fill: #ffab00;
    stroke: #fff;
}
  
.focus circle {
  fill: none;
  stroke: steelblue;
}
.canvas {    
    position:absolute;      
}
.svg{
  position: relative;
}
.grid line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}

.grid path {
  stroke-width: 0;
}

.legendTitle {    
    fill: #000;
}

.overlay {
  fill: none;
  stroke: none;  
}
.focusLine {
    fill: none;
      stroke: grey;
      stroke-width: 0.5px;
  }

  .focusCircle {     
      fill: none; 
      stroke: red;
  }

  .caption{
    line-height: initial;
  }

  .zoom{
    cursor: zoom-in!important;
  }

  rect.zoom {
    stroke: steelblue;
    fill-opacity: 0.5;
  }

  .backcanvas{
    background-color: #fff;
  }


</style>